import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import colors from 'shared-components/theme/colors';
import Media from 'shared-components/theme/medias';
import { gilroyBold, gilroyMedium, gilroyRegular } from 'shared-components/theme/fonts';
import Button from 'shared-components/button/button';
import ReactHtmlParser from 'react-html-parser';
import { handleMenuTarget } from 'shared-components/theme/helpers';
import { handleUrl, baseURLPage, baseURL } from 'shared-components/theme/helpers';
// import { GrClose } from 'react-icons/gr';
// import { FaChevronLeft, FaLinkedinIn } from 'react-icons/fa';
// import { FaArrowLeft } from 'react-icons/fa';

const MobileMenu = ({ data, openCxFormPopup }) => {
    const [open, setOpen] = useState(false);
    const [activeSubMenuIndex, setActiveSubMenuIndex] = useState(null);

    useEffect(() => {
        return () => {
            setOpen(false);
            setActiveSubMenuIndex(null);
        };
    }, []);

    const handleSubMenuClick = (e, index) => {
        e.preventDefault();
        setActiveSubMenuIndex(index);
    };

    const handleBackClick = () => {
        setActiveSubMenuIndex(null);
    };

    const handleClose = () => {
        setOpen(false);
        setActiveSubMenuIndex(null);
    };

    const activeMenuData = activeSubMenuIndex !== null && data && data[activeSubMenuIndex] ? data[activeSubMenuIndex] : null;

    const SubMenu = ({ parentTitle, item }) => {
        const image = item.menu_icon_mobile ? item.menu_icon_mobile : item.menu_icon ? item.menu_icon : item.menu_image;
        return (
            <SubWrapper
                as="a"
                href={handleUrl(item.url)}
                target={item.target === '_blank' ? '_blank' : '_self'}
                rel={item.target === '_blank' ? 'noopener noreferrer' : 'none'}>
                <SubMenuImg isWaveix={parentTitle === 'Wave iX'}>
                    <img
                        src={image}
                        alt={(item.mobileIconAlt && item.mobileIconAlt) || '-'}
                    />
                </SubMenuImg>
                <SubMenuText>
                    <span className='title'>
                        {ReactHtmlParser(item.title)}
                    </span>
                    <span className='description'>
                        {ReactHtmlParser(item.menu_description)}
                    </span>
                </SubMenuText>
            </SubWrapper>
        );
    };

    return (
        <Wrapper>
            <MenuBtn open={open} onClick={() => setOpen(!open)}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </MenuBtn>
            <MenuWrapper open={open}>
                <MenuContainer activeSubMenu={activeSubMenuIndex}>
                    <MainMenuView active={activeSubMenuIndex === null}>
                        <MenuList>
                            {data && data.length > 0
                                ? data.map((val, index) => {
                                    return val.children &&
                                        val.children.length > 0 ? (
                                        <MenuItemDropdown key={index}>
                                            <MenuItemLink
                                                href={handleUrl(val.url)}
                                                onClick={(e) => handleSubMenuClick(e, index)}
                                                active={activeSubMenuIndex === index}>
                                                {ReactHtmlParser(val.title)}
                                            </MenuItemLink>
                                        </MenuItemDropdown>
                                    ) : (
                                        <MenuItem key={index}>
                                            {handleMenuTarget(val)}
                                        </MenuItem>
                                    );
                                })
                                : null}
                        </MenuList>
                        <MenuFooter>
                            <BuildCtxBtn>
                                <Button round={true} href={`${baseURLPage}contact-us`}>
                                    Contact Us
                                </Button>
                            </BuildCtxBtn>
                        </MenuFooter>
                    </MainMenuView>

                    <SubMenuView active={activeSubMenuIndex !== null}>
                        {activeMenuData && (
                            <>
                                <SubMenuHeader>
                                    <BackButton onClick={handleBackClick}>
                                        <SubMenuTitle active={true}>
                                            {ReactHtmlParser(activeMenuData.title)}
                                        </SubMenuTitle>
                                    </BackButton>
                                </SubMenuHeader>
                                <SubMenuList>
                                    {activeMenuData.children.map((item, ind) => {
                                        return <SubMenu parentTitle={activeMenuData.title} item={item} key={ind} />;
                                    })}
                                </SubMenuList>
                                <SubMenuFooter>
                                    <BackButtonLarge onClick={handleBackClick}>
                                        Back
                                    </BackButtonLarge>
                                </SubMenuFooter>
                            </>
                        )}
                    </SubMenuView>
                </MenuContainer>
            </MenuWrapper>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    position: relative;
    display: none;
    align-items: center;
    justify-content: flex-end;
    ${Media('tablet')} {
        display: flex;
    }
`;

const MenuBtn = styled.a`
    position: relative;
    z-index: 999;
    width: 50px;
    height: 50px;
    cursor: pointer;
    span {
        display: block;
        position: absolute;
        height: 2px;
        width: 26px;
        background: ${colors.gray_dark['100']};
        opacity: 1;
        left: calc(50% - 13px);
        margin-bottom: 5px;
        border-radius: 9px;
        transform: scale(1);
        transform: rotate(0deg);
        transition: all 0.3s ease-in-out;
        &:nth-child(1) {
            top: ${(props) => (props.open ? '29px' : '19px')};
            transform: ${(props) => (props.open ? 'scale(0)' : 'scale(1)')};
        }
        &:nth-child(2) {
            top: 27px;
            transform: ${(props) =>
        props.open ? 'rotate(-45deg)' : 'rotate(0deg)'};
        }
        &:nth-child(3) {
            top: 27px;
            transform: ${(props) =>
        props.open ? 'rotate(45deg)' : 'rotate(0deg)'};
        }
        &:nth-child(4) {
            top: 35px;
            transform: ${(props) => (props.open ? 'scale(0)' : 'scale(1)')};
        }
    }
`;

const MenuWrapper = styled.div`
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 998;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-color: ${colors.white['100']};
    transition: all 0.5s ease;
    transform: ${(props) =>
        props.open ? 'translateX(0)' : 'translateX(100%)'};
    display: flex;
    flex-direction: column;
`;

const MenuHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 30px;
    border-bottom: 1px solid ${colors.gray_dark['10']};
    position: relative;
`;

const MenuTitle = styled.h2`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-size: 14px;
    font-family: ${gilroyMedium};
    color: ${colors.gray_dark['100']};
    margin: 0;
    text-align: center;
`;

const Logo = styled.a`
    display: flex;
    align-items: center;
    height: 30px;
    img,
    svg {
        width: auto;
        height: 30px;
    }
`;

const CloseBtn = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: ${colors.gray_dark['100']};
    svg {
        width: 24px;
        height: 24px;
    }
`;

const MenuContainer = styled.div`
    position: relative;
    flex: 1;
    overflow: hidden;
    width: 200%;
    display: flex;
    transition: transform 0.3s ease;
    padding-top: 80px;
    transform: ${(props) =>
        props.activeSubMenu !== null && props.activeSubMenu !== undefined
            ? 'translateX(-50%)'
            : 'translateX(0)'};
`;

const MainMenuView = styled.div`
    width: 50%;
    height: 100%;
    overflow-y: auto;
    padding: 0;
    display: flex;
    flex-direction: column;
    transform: ${(props) => (props.active ? 'translateX(0)' : 'translateX(-100%)')};
    transition: transform 0.5s ease;
`;

const SubMenuView = styled.div`
    width: 50%;
    height: 100%;
    overflow-y: auto;
    padding: 0;
    display: flex;
    flex-direction: column;
    transform: ${(props) => (props.active ? 'translateX(0)' : 'translateX(100%)')};
    transition: transform 0.5s ease;
`;

const MenuList = styled.div`
    flex: 1;
    padding: 0px 20px 20px;
    overflow-y: auto;
`;

const SubMenuList = styled.div`
    flex: 1;
    padding: 0px 20px;
    overflow-y: auto;
`;

const MenuItem = styled.div`
    padding: 23px 10px;
    border-bottom: 1px solid ${colors.gray_dark['10']};
    a {
        display: inline-block;
        position: relative;
        color: ${colors.gray_dark['100']};
        font-family: ${gilroyMedium};
        font-size: 20px;
        text-decoration: none;
        &:hover {
            color: ${colors.pink['100']};
        }
    }
`;

const MenuItemDropdown = styled(MenuItem)`
    a {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        &:after {
            content: "";
            width: 11px;
            height: 11px;
            border-right: 2px solid ${colors.gray_dark['50']};
            border-bottom: 2px solid ${colors.gray_dark['50']};
            transform: rotate(-45deg);
            transition: transform 0.25s ease, border-color 0.25s ease;
        }
    }
`;

const MenuItemLink = styled.a`
    color: ${(props) =>
        props.active ? colors.pink['100'] : colors.gray_dark['100']} !important;
    font-family: ${gilroyMedium};
    font-size: 20px;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

const MenuFooter = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    a {
        padding-block: 15px;
    }
`;

const SocialIcons = styled.div`
    display: flex;
    gap: 15px;
    align-items: center;
`;

const SocialIcon = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.gray_dark['100']};
    font-size: 20px;
    text-decoration: none;
    img {
        height: 17px;
    }
    svg {
        font-size: 20px;
    }
`;

const BuildCtxBtn = styled.div`
    a {
        font-family: ${gilroyBold};
        width: 100%;
        display: block;
        text-align: center;
    }
`;

const SubMenuHeader = styled.div`
    padding: 20px 10px;
    margin-inline: 20px;
    border-bottom: 1px solid ${colors.gray_dark['10']};
`;

const BackButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.pink['100']};
    font-size: 20px;
    display: flex;
    align-items: center;
    gap: 15px;
    svg {
        width: 20px;
        height: 20px;
    }
`;

const SubMenuTitle = styled.div`
    font-size: 20px;
    font-family: ${gilroyMedium};
    color: ${(props) =>
        props.active ? colors.pink['100'] : colors.gray_dark['100']};
    flex: 1;
    padding-left: 30px;
    position: relative;
    &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 40%;
        width: 11px;
        height: 11px;
        border-left: 2px solid ${colors.pink['100']};
        border-bottom: 2px solid ${colors.pink['100']};
        transform: rotate(45deg) translateY(-50%);
        transition: transform 0.25s ease, border-color 0.25s ease;
    }
`;

const SubWrapper = styled.a`
    display: flex !important;
    align-items: flex-start;
    padding: 23px 10px;
    border-bottom: 1px solid ${colors.gray_dark['10']};
    text-decoration: none;
    gap: 15px;
    position: relative;
    /* &:after {
        content: "";
        position: absolute;
        right: 0;
        top: 50%;
        width: 11px;
        height: 11px;
        border-right: 2px solid ${colors.gray_dark['50']};
        border-bottom: 2px solid ${colors.gray_dark['50']};
        transform: rotate(-45deg) translateY(-50%);
        transition: transform 0.25s ease, border-color 0.25s ease;
    } */
`;

const SubMenuImg = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    ${props => props.isWaveix && `
        width: 60px;
        height: 60px;
        border-radius: 8px;
        overflow: hidden;
    `}
`;

const SubMenuText = styled.div`
    margin: 0px;
    font-family: ${gilroyMedium};
    flex: 1;
    display: inline-flex;
    flex-direction: column;
    p {
        font-size: inherit;
        font-family: inherit;
        color: inherit;
        line-height: inherit;
        margin: 0;
    }
    .title {
        font-size: 16px;
        line-height: 1.2;
        font-family: ${gilroyMedium};
        color: ${colors.gray_dark['100']};
        margin-bottom: 8px;
    }
    .description {
        font-size: 14px;
        line-height: 1.2;
        font-family: ${gilroyRegular};
        color: ${colors.gray_dark['75']};
    }
    br {
        display: none;
    }
`;

const SubMenuFooter = styled.div`
    padding: 20px;
`;

const BackButtonLarge = styled.button`
    width: 100%;
    padding: 15px;
    background-color: ${colors.gray_dark['100']};
    color: ${colors.white['100']};
    border: none;
    border-radius: 30px;
    font-family: ${gilroyMedium};
    font-size: 16px;
    cursor: pointer;
    text-align: center;
`;

export default MobileMenu;
